<email-layout>
  <ng-container logo>
    <email-tellent-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data().header" [subheader]="data().subheader" />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data().body" />
    <email-margin [height]="28" />
    <email-button
      [href]="data().primary_cta.href"
      [label]="data().primary_cta.label"
      theme="primary"
    />
    <email-margin [height]="28" />
    <email-text [contents]="data().text" size="small" color="light" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data().footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data().footer.label"
      [href]="data().footer.href"
      [target]="data().footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
    <email-margin [height]="16" />
    <email-tellent-products-footer />
  </ng-container>
</email-layout>
